export default function getMeta(metaName: string) {
  const metas = Array.from(document.getElementsByTagName('meta'));
  if (metas.length) {
    const metaTag = metas.find(meta => {
      const name = meta.getAttribute('name');
      return name === metaName;
    });
    if (metaTag) {
      return metaTag.getAttribute('content');
    }
  }
  return '';
}
